import { render, staticRenderFns } from "./highlights-sop.vue?vue&type=template&id=96fbac90&scoped=true&"
import script from "./highlights-sop.vue?vue&type=script&lang=js&"
export * from "./highlights-sop.vue?vue&type=script&lang=js&"
import style0 from "./highlights-sop.vue?vue&type=style&index=0&id=96fbac90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fbac90",
  null
  
)

export default component.exports